import { Card, CardBody } from '@nextui-org/react';
import React from 'react';

const Contact: React.FC = () => {
  return (
    <div>
      <div className="mb-8">
        <h1 className="text-2xl font-bold text-slate-800">Support</h1>
        <p className="text-sm text-slate-500 mt-1">
          Get in touch with your dedicated partner representative
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-w-2xl">
        <Card className="bg-white border border-slate-200 shadow-none">
          <CardBody className="p-6">
            <div className="flex items-start gap-4">
              <div className="p-2 bg-airlock-light rounded-lg flex-shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-airlock-purple"
                >
                  <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
                  <polyline points="22,6 12,13 2,6" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                  Email
                </p>
                <a
                  href="mailto:elizabeth@airlockusa.com"
                  className="text-sm font-medium text-airlock-purple hover:underline"
                >
                  elizabeth@airlockusa.com
                </a>
              </div>
            </div>
          </CardBody>
        </Card>

        <Card className="bg-white border border-slate-200 shadow-none">
          <CardBody className="p-6">
            <div className="flex items-start gap-4">
              <div className="p-2 bg-airlock-light rounded-lg flex-shrink-0">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="text-airlock-purple"
                >
                  <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h3a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0122 16.92z" />
                </svg>
              </div>
              <div>
                <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                  Phone
                </p>
                <a
                  href="tel:+19546230970"
                  className="text-sm font-medium text-slate-800"
                >
                  (954) 623-0970
                </a>
              </div>
            </div>
          </CardBody>
        </Card>
      </div>

      <Card className="bg-white border border-slate-200 shadow-none mt-4 max-w-2xl">
        <CardBody className="p-6">
          <div className="flex items-start gap-4">
            <div className="p-2 bg-airlock-light rounded-lg flex-shrink-0">
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="text-airlock-purple"
              >
                <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </div>
            <div>
              <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-1">
                Your Representative
              </p>
              <p className="text-sm font-medium text-slate-800">Elizabeth West</p>
              <p className="text-xs text-slate-400 mt-1">
                AIRLOCK Partner Relations
              </p>
            </div>
          </div>
        </CardBody>
      </Card>
    </div>
  );
};

export default Contact;
